export default __webpack_public_path__ + "static/view-groups-light-mode-b1b00edf3f0a50887db13217bf4b6d22.png";